import script from "./MarketingPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingPerformance.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BarChart from "@/components/BarChart.vue";
script.components = Object.assign({}, { BarChart }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BarChart }, script.__o.components);}